<script lang="ts">
  import {createEventDispatcher, onMount} from "svelte"
  import {globalSearch, groups, isDirtySearch, list} from "../../../../../stores";
  import {getFixedNews} from "../../../services"
  import {fixedNews, selectedGroup} from "../../../store"
  import type {IGroup} from "../../../types"

  import MobileTabs from "./MobileTabs.svelte"
  import {searchPublications} from "../../../../../custom/GlobalSearch/services/index.js";

  const isMobile: boolean = screen.width <= 576;
    const dispatch = createEventDispatcher<{
        'start-loading',
        'end-loading'
    }>();

    let selectedSlug = '';

	const getSvg = (color: string) => {
		return `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 2.75C2.86193 2.75 2.75 2.86193 2.75 3V17C2.75 17.1381 2.86193 17.25 3 17.25H17C17.1381 17.25 17.25 17.1381 17.25 17V3C17.25 2.86193 17.1381 2.75 17 2.75H3ZM9.32257 5.76545L6.15669 4.09848H9.32253L9.32257 5.76545ZM10.6775 5.76546L10.6775 4.09848H13.8434L10.6775 5.76546ZM4.10496 14.3717V4.54376L9.01657 7.12992L4.10496 14.3717ZM15.895 14.3717L10.9836 7.12992L15.895 4.54377V14.3717ZM15.2979 15.9015H4.70215L10.0001 8.09014L15.2979 15.9015Z" fill="${color}"/>
            </svg>
	    `
	}

    const updateGroup = async (item: IGroup) => {
        dispatch('start-loading')

        $selectedGroup = item
        $list = []
        $fixedNews = []
        $isDirtySearch = false
        $globalSearch = ''

        await Promise.all([
          searchPublications({
            orderingGroup: $selectedGroup.slug === 'physical_transformation' ? 'feed' : 'rpp',
            feedGroup: $selectedGroup.slug,
          }),
            getFixedNews()
        ]);

        dispatch('end-loading')
    }

	const changeTab = async (item: IGroup) => {
		selectedSlug = item.slug;

        localStorage.setItem('currentTab', JSON.stringify(item));

        await updateGroup(item)
	}

    const onChangeGroups = async (event: CustomEvent<{ option: IGroup }>): Promise<void> => {
        await updateGroup(event.detail.option)
    }

    onMount(() => {
        if ($selectedGroup) {
            selectedSlug = $selectedGroup.slug
        }
    })
</script>

{#if isMobile && $groups.length}
    <MobileTabs on:change={onChangeGroups} />
{:else}
    <div class="groups text-bold">
        {#each $groups as item (item.slug) }
            <div
                class="group"
                style="border-bottom: {selectedSlug === item.slug ? `2px solid ${item.color}` : '2px solid transparent'}"
                style:color={selectedSlug === item.slug ? '#5A5F6D' : 'rgba(90, 95, 109, 0.6)'}
                on:click={() => changeTab(item)}
            >
                <div class="icon" class:selected={selectedSlug === item.slug}>
                    {@html getSvg(item.color)}
                </div>

                <div>{item.title}</div>
            </div>
        {/each}
    </div>
{/if}

<style>
	.groups {
		display: flex;
        margin-bottom: 16px;
	}

	.group {
		cursor: pointer;
		display: flex;
		align-items: center;
		padding-bottom: 18px;
		padding-left: 16px;
		padding-right: 16px;
		padding-top: 3px;
        transition: all .2s;
	}

	.icon {
		margin-right: 4px;
		display: flex;
        opacity: .2;
	}

    .icon.selected {
        opacity: 1;
    }
</style>